import { memo } from 'react';
import { ShopItemList } from '../components';
import { Screen } from '@bonanza-social/navigation';
import { Box } from '@bonanza-social/moonlight';
import usePromotion from '../hooks/usePromotion';
import ShopStatusPromotionBanner from '../components/ShopStatusPromotionBanner/ShopStatusPromotionBanner';

function ShopScreen() {
  const promotion = usePromotion();

  return (
    <Screen paddingHorizontal="space-0">
      <Box position="relative" flex={1}>
        <ShopItemList
          paddingBottom={promotion ? 'space-3000' : 'safe-area-inset-bottom'}
        />
        <ShopStatusPromotionBanner />
      </Box>
    </Screen>
  );
}

export default memo(ShopScreen);
